module.exports = __webpack_public_path__ + "img/3.f3f1f819.png";